import emailjs from "@emailjs/browser";

const SERVICE    = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const PUB_KEY    = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
const T_SIGNUP   = process.env.REACT_APP_EMAILJS_TEMPLATE_SIGNUP;
const T_CONTACT  = process.env.REACT_APP_EMAILJS_TEMPLATE_CONTACT;

export function sendTeacherApplication(form) {
  return emailjs.send(SERVICE, T_SIGNUP, {
    applicant_name:       form.name,
    applicant_email:      form.email,
    applicant_phone:      form.phone,
    applicant_city:       form.city,
    applicant_education:  form.education,
    applicant_experience: form.experience,
    applicant_why:        form.why,
  }, PUB_KEY);
}

export function sendNewsletterSignup(email) {
  return emailjs.send(SERVICE, T_SIGNUP, { subscriber_email: email }, PUB_KEY);
}

export function sendContactMessage(email, message) {
  return emailjs.send(SERVICE, T_CONTACT, {
    applicant_email: email,
    applicant_message: message,
  }, PUB_KEY);
}
